module.exports = __webpack_public_path__ + "img/logo.07110b0c.png";